module.exports = __webpack_public_path__ + "media/images/360/insomnia_moon_dark_skies-cd99e051783ea3c3bf2e5688555949aa.jpg";